import DashboardApiTableShow, {DashboardColumn} from './DashboardApiTableShow'
import {NotYetListedItem} from './dashboardTableTypes'
import {renderDashboardLink, renderDashboardSku, renderDashboardStatusPill} from './dashboardFormatters'

const columns: DashboardColumn<NotYetListedItem>[] = [
  {header: 'SKU', sortKey: 'sku', render: (item) => renderDashboardSku(item.sku)},
  {header: 'Channel', sortKey: 'channel', render: (item) => item.channel ?? '-'},
  // {header: 'Broken Link', render: (item) => renderDashboardLink(item.broken_link)},
  // {header: 'Error Message', render: (item) => item.error_message ?? '-'},
  // {header: 'Scraped Price', render: (item) => item.scraped_price ?? '-'},
  {header: 'Product Status', sortKey: 'product_status', render: (item) => renderDashboardStatusPill(item.product_status)},
  {header: 'Type', sortKey: 'type', render: (item) => item.type ?? '-'},
]

function NotYetListedShow() {
  return <DashboardApiTableShow<NotYetListedItem> endpoint='NotYetListed' title='Not Yet Listed' columns={columns} />
}

export default NotYetListedShow
